<template>
  <div class="break section-block row-box">
    <WrapperField
      v-for="(value, index) in data"
      :key="value + index + Math.random()"
      :data="
        createDataField({
          fieldName: index,
          fieldValue: value,
          fieldGroup: isAssignee ? FieldGroup.ASSIGNEE : FieldGroup.TRUSTEE,
        })
      "
    ></WrapperField>
    <Block
      v-if="identityDocument"
      :data="identityDocument"
      :field-group="FieldGroup.IDENTITY_DOCUMENT"
    />

    <template v-if="!documentsHidden">
      <!-- Реквизиты документа, подтверждающего должность или статус представителя -->
      <TitleField
        v-if="statusDocument"
        fieldName="isStatusDocument"
        :fieldGroup="FieldGroup.TRUSTEE"
      />
      <WrapperField
        v-for="(value, index) in statusDocument"
        :key="value + index + Math.random()"
        :data="
          createDataField({
            fieldName: index,
            fieldValue: value,
            fieldGroup: FieldGroup.TRUSTEE,
          })
        "
      ></WrapperField>

      <!-- Реквизиты документа, подтверждающего полномочия представителя -->

      <template v-if="isAuthorityDocumentVisible">
        <TitleField
          fieldName="isAuthorityDocument"
          :fieldGroup="FieldGroup.TRUSTEE"
        />
        <WrapperField
          v-for="(value, index) in authorityDocument"
          :key="value + index + Math.random()"
          :data="
            createDataField({
              fieldName: index,
              fieldValue: value,
              fieldGroup: FieldGroup.TRUSTEE,
              fieldGroupEdit: authorityDocumentFieldGroupEdit,
            })
          "
        ></WrapperField>
      </template>
    </template>
  </div>
</template>

<script>
import { createDataField, FieldGroup } from '@/utils/fullStatementView';
import WrapperField from '@/components/elements/statement/FullStatementView/base/WrapperField';
import TitleField from '@/components/elements/statement/FullStatementView/base/TitleField';
import Block from '@/components/elements/statement/FullStatementView/elements/Block';
import { DocumentType } from '@/types/services';

export default {
  name: 'Trustee',
  components: {
    WrapperField,
    TitleField,
    Block,
  },
  props: {
    data: {
      type: Object,
    },
    documentsHidden: {
      type: Boolean,
    },
    isAssignee: {
      type: Boolean,
    },
  },
  data: () => ({
    createDataField,
    FieldGroup,
  }),
  computed: {
    isNotaryDocument() {
      return this.authorityDocument.type === DocumentType.NOTARY_POWER_ATTORNEY;
    },

    authorityDocumentFieldGroupEdit() {
      return this.isNotaryDocument ? FieldGroup.NOTARY_DOCUMENT : undefined;
    },

    identityDocument() {
      return this.data?.documents?.identityDocument;
    },

    statusDocument() {
      return this.data?.documents?.statusDocument;
    },

    authorityDocument() {
      return this.data?.documents?.authorityDocument;
    },

    isMrpaAurthorityDocument() {
      return this.authorityDocument?.type === DocumentType.MRP;
    },

    isAuthorityDocumentVisible() {
      return this.authorityDocument && !this.isMrpaAurthorityDocument;
    },
  },
};
</script>
